import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, createBaseQuery } from '../base/baseApi';

export const authApi = createApi({
    tagTypes: ['Auth'],
    reducerPath: 'authApi',
    baseQuery: createBaseQuery({
        baseUrl: API_BASE_URL,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    }),
    endpoints: (builder) => ({
        register: builder.mutation({
            query: (userData) => ({
                url: '/auth/register',
                method: 'POST',
                body: userData,
            }),
            transformResponse: (response) => response.Data,
        }),
        login: builder.mutation({
            query: (loginData) => ({
                url: '/auth/login',
                method: 'POST',
                body: loginData,
            }),
            transformResponse: (response) => response.Data,
        }),
        googleLogin: builder.mutation({
            query: (data) => ({
                url: '/auth/google-login',
                method: 'POST',
                body: data,
            }),
            transformResponse: (response) => response.Data,
        }),
        demoAccess: builder.mutation({
            query: (userId) => ({
                url: `/demo/access/${userId}`,
                method: 'GET',
            }),
            transformResponse: (response) => response.Data,
        }),
        sendOTP: builder.mutation({
            query: () => ({
                url: '/auth/send-otp',
                method: 'POST',
            }),
        }),
        verifyOTP: builder.mutation({
            query: (otp) => ({
                url: '/auth/verify-otp',
                method: 'POST',
                body: { OTP: otp },
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
            }),
        }),
        refreshToken: builder.mutation({
            query: () => ({
                url: '/auth/refresh-token',
                method: 'PUT',
                credentials: 'include',
            }),
            transformResponse: (response) => response.Data,
        }),
        createSubscriptionTicket: builder.mutation({
            query: (data) => ({
                url: '/subscriptions/create-session',
                method: 'POST',
                body: data,
            }),
            transformResponse: (response) => response.Data,
        }),
        validateSubscriptionStatus: builder.mutation({
            query: (sessionId) => ({
                url: '/subscriptions/validate-status',
                method: 'POST',
                body: { session_id: sessionId },
            }),
        }),
        cancelSubscription: builder.mutation({
            query: () => ({
                url: '/subscriptions/cancel-subscription',
                method: 'PUT',
            }),
        }),
        deleteAccount: builder.mutation({
            query: () => ({
                url: '/user-profile/delete',
                method: 'PUT',
            }),
        }),
        changePassword: builder.mutation({
            query: ({ oldPassword, newPassword, repeatPassword }) => ({
                url: '/user-profile/update-password',
                method: 'PUT',
                body: {
                    Old_Password: oldPassword,
                    New_Password: newPassword,
                    New_Password_confirmation: repeatPassword
                },
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useRegisterMutation,
    useGoogleLoginMutation,
    useDemoAccessMutation,
    useLogoutMutation,
    useSendOTPMutation,
    useVerifyOTPMutation,
    useRefreshTokenMutation,
    useCreateSubscriptionTicketMutation,
    useValidateSubscriptionStatusMutation,  
    useCancelSubscriptionMutation,
    useDeleteAccountMutation,
    useChangePasswordMutation,
} = authApi;
